import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  closeModal,
  getRandomPastelColor,
  isBlank,
  submitAnnualPlannerAction,
} from "../../../utils/annual-planner-helpers";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import DateInput from "../../inputs/date-input";
import Modal from "../../modal-new";

export const AddEventModal = ({
  from,
  to,
  athleteId,
  date,
  locals,
  organizationCoachId,
}) => {
  const { t } = useTranslation("coaching-portal");

  const [formState, setFormState] = useState(() => ({
    event_name: "",
    event_color: getRandomPastelColor(),
    event_from: from,
    event_to: to,
    event_description: "",
  }));

  const { event_name, event_color, event_from, event_to, event_description } =
    formState;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      isBlank(event_name) ||
      !event_color ||
      !event_from ||
      isBlank(event_description)
    )
      return;
    submitAnnualPlannerAction(
      "/actions/annual-planner/add-calendar-event",
      {
        athleteId,
        date,
        event_name,
        event_color,
        event_from,
        event_to,
        event_description,
        modalUrl: locals.path,
        modalParams: locals.query,
      },
      organizationCoachId
    );
  };

  const handleChange = (input, payload) => {
    setFormState({ ...formState, [input]: payload });
  };

  return (
    <Modal
      className="annual-planner-modal add-event-modal"
      title={t("addEventModal.title")}
    >
      <div className="body">
        <form
          className="annual-planner-modal-form add-event-modal-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          id="add-event-form"
        >
          <div role="wrapper" className="flex-row">
            <div role="wrapper" className="event-name">
              <label className="label">
                {t("addEventModal.eventNameLabel")}
              </label>
              <input
                type="text"
                name="event_name"
                className="event-name"
                placeholder={t("addEventModal.placeholderTitle")}
                value={event_name}
                onChange={({ target: { value } }) =>
                  handleChange("event_name", value)
                }
              />
            </div>
            <div role="wrapper" className="event-color">
              <label className="label">{t("addEventModal.colorLabel")}</label>
              <InputColor
                onChange={({ target: { value } }) =>
                  handleChange("event_color", value)
                }
                value={event_color}
                customClassNames={"event-color"}
              />
            </div>
          </div>
          <div role="wrapper" className="flex-row">
            <div role="wrapper" className="event-from">
              <label className="label">{t("addEventModal.dateLabel")}</label>
              <DateInput
                customClassNames="event-from"
                name="event_from"
                defaultValue={
                  event_from && moment(`${event_from}`).format("YYYY-MM-DD")
                }
                forceOnChange={true}
                onChange={(newDate) =>
                  handleChange(
                    "event_from",
                    Number(moment(newDate, "MMM D, YYYY").format("YYYYMMDD"))
                  )
                }
                datePlaceholder={t("addEventModal.datePlaceholderStart")}
              />
            </div>
            <div role="wrapper" className="event-to">
              <label className={`label${!event_from ? " disabled" : ""}`}>
                {t("addEventModal.dateRangeOptionalLabel")}
              </label>
              <DateInput
                customClassNames="event-to"
                name="event_to"
                defaultValue={
                  event_to && moment(`${event_to}`).format("YYYY-MM-DD")
                }
                forceOnChange={true}
                disabled={!event_from}
                onChange={(newDate) =>
                  handleChange(
                    "event_to",
                    Number(moment(newDate, "MMM D, YYYY").format("YYYYMMDD"))
                  )
                }
                datePlaceholder={t("addEventModal.datePlaceholderEnd")}
              />
            </div>
          </div>
          <div role="wrapper" className="event-description">
            <label>{t("addEventModal.descriptionLabel")}</label>
            <textarea
              name="event_description"
              className="event-description"
              placeholder={t("addEventModal.placeholderDescription")}
              value={event_description}
              onChange={({ target: { value } }) =>
                handleChange("event_description", value)
              }
            />
          </div>
        </form>
      </div>
      <footer className="add-event-footer">
        <button
          type="button"
          role="button"
          data-action="cancel"
          onClick={closeModal}
        >
          {t("common:cancel")}
        </button>
        <button
          form="add-event-form"
          type="submit"
          role="button"
          data-button-type="primary"
          disabled={
            isBlank(event_name) ||
            !event_color ||
            !event_from ||
            isBlank(event_description)
          }
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};
